/* eslint-disable */
require('./announcement')
require('./archive')
require('./arrow')
require('./back')
require('./banner-manager')
require('./banner-multiple')
require('./banner-single')
require('./book')
require('./calendar')
require('./chart')
require('./check')
require('./cog')
require('./cross')
require('./dashboard')
require('./delete')
require('./document-create')
require('./dots')
require('./download')
require('./drag')
require('./drop-arrow')
require('./duplicate')
require('./edit')
require('./element-accordion')
require('./element-button')
require('./element-callout')
require('./element-gallery')
require('./element-heading')
require('./element-image')
require('./element-resource-list')
require('./element-text-block')
require('./element-video')
require('./element-group')
require('./file')
require('./grid')
require('./groups')
require('./hr')
require('./hub')
require('./icon-corporate')
require('./icon-hive')
require('./iframe')
require('./list')
require('./medal')
require('./menu')
require('./mixer')
require('./move')
require('./move-side')
require('./notifications')
require('./page')
require('./pencil')
require('./people')
require('./plus-circle')
require('./poll')
require('./preview')
require('./pulse')
require('./qr-code')
require('./search')
require('./share')
require('./shield')
require('./signal')
require('./spark')
require('./stack')
require('./star')
require('./star--filled')
require('./surveys')
require('./text')
require('./tick')
require('./upload')
require('./link-arrow')
require('./clock')
require('./attachment')
require('./questionRound')
require('./lightbulb')
require('./thumbsup')
require('./comments')
require('./view')
require('./addUser')
require('./save')
require('./replies')
require('./pin')
require('./book-open')
require('./link')
require('./mail')
require('./phone')
require('./alert')
require('./logout')
require('./alert-circle')
